// extracted by mini-css-extract-plugin
export default {"dotSpinner":"loading_dotSpinner__gVgWM","dotSpinner__dot":"loading_dotSpinner__dot__OTdvE","pulse0112":"loading_pulse0112__kZxI6"};